/**
 * Angular imports.
 */
import { Component, Output, EventEmitter, Input, OnDestroy, OnChanges } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Service imports.
 */
import { NewLanguageService } from './../../dataservices/new-language/new-language.service';
import { GetwebService } from '../../dataservices/web/getweb.service';
import { MultiLangService } from '../../dataservices/master-service/multi-lang.service';
import { EventMsgService } from '../../dataservices/master-service/event-msg.service';
import { MasterserviceService } from '../../dataservices/master-service/masterservice.service';
import { EncryptionService } from '../../auth/encryption.service';
import { AuthService } from '../../auth/auth.service';
import { LocalstorageService } from '../../auth/localstorage.service';
import { PostApiService } from '../../dataservices/post-api.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { JwtDecodeService } from '../../dataservices/jwt-decode.service';
import { DataStorageService } from '../../dataservices/data-storage.service';

/**
 * Interface imports.
 */
import { UserProfileRoot } from '../../interface/userprofile/userprofile';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';
/**
 * Import constants.
 */
import {REPOST_STATUS, PRODUCT_TYPE_CONSTANT, NUMBERS, POSTING_PROGRESS, SCREEN_SHARING, SCREEN_NAME } from './../../constants/app.constants';

/**
 * Feed Detail Modal Component
 */
@Component({
  selector: 'app-feed-detail-modal',
  templateUrl: './feed-detail-modal.component.html',
  styleUrls: ['./feed-detail-modal.component.scss']
})
export class FeedDetailModalComponent implements OnDestroy, OnChanges {

  @Output() resetFeedDetailModal = new EventEmitter();
  @Input() feedDetailModal;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  feedObject: any;
  @Input() mediaIdx;
  @Input() feedIdx;
  @Input() feedId;
  /**
   * EC id if user open it from ec card.
   */
  @Input() ecId?: number;
  /**
   * posted click event
   */
  @Input() isPostedEvent?:boolean;

  public pdfSrc = './assets/sample.pdf';
  public see_more = false;
  public screen_name: string;
  public commentObj; // Comment Component Object
  public showComment = false;
  public showLikeListModal = false;
  public feed_like_loader = false;
  public feed_bookmark_loader = false;
  public bookmarkObj;
  public is_bookmark = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public channelDetail: any;
  public useractivity = false;
  public loginUserCustomeId: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public likeObj: any;
  public userProfileData: UserProfileRoot;
  public keyboard = false;
  public comment_box_obj = { profile_pic: '', product_type_id: '', product_id: '' };
  

  private source: string;
  /**
   * To unsubscribe data.
   */
   private subscriptions: Subscription = new Subscription();

  /**
   * Necessary instances.
   */
  constructor(
    private dss: DataStorageService,
    private gws: GetwebService,
    public ems: EventMsgService,
    private jwtSer: JwtDecodeService,
    public multiLangService: MultiLangService,
    private masterService: MasterserviceService,
    private authService: AuthService,
    private localStorage: LocalstorageService,
    private postSer: PostApiService,
    public fcs: FunCollectionService,
    public mls: NewLanguageService,
    private encrypt: EncryptionService,
    private router: Router
  ) {
  }

  ngOnChanges(): void {
    this.feedObject = null;
    this.subscriptions.add(this.dss.feedDetailChanged.subscribe(data => {
      if (data.type == 'feed') {
        this.feedId = data.id;
        this.feedLoad();
      }
    }));
    this.feedLoad();
    this.source = this.fcs.currentScreename;
  }

  /**
   * feed Load
   */
  feedLoad(): void {
    this.loginUserCustomeId = this.authService.getbyName('profile_obj');
    if (sessionStorage.getItem('userProfileData') != null) {
      this.userProfileData = (JSON.parse(this.encrypt.decryptAes(this.localStorage.getInSessionStorage('userProfileData'))));
      this.comment_box_obj.profile_pic = this.userProfileData['profile'].profile_pic_path;

    }

    this.subscriptions.add(this.gws.getfeedetailNew(this.feedId).subscribe(resData => {
      this.jwtSer.decodeData(resData).then(data => {
        if (data.status == 1) {
          this.feedObject = data.data['feed'];
          this.comment_box_obj.product_type_id = '1';
          this.comment_box_obj.product_id = this.feedObject.feed_id;
          if (this.feedObject.user_profile == null) {
            if (this.feedObject.channel != null) {
              this.channelDetail = { custom_id: 'not_show', chat_id: this.feedObject.channel.channel_id, connection_status: '', is_connect_enable: '', permission: '', profile_pic: this.feedObject.channel.channel_logo, registered_name: this.feedObject.channel.title, specialities: '', 'target_id': this.feedObject.channel.channel_id, 'full_name': this.feedObject.channel.title, 'channel_name': this.feedObject.channel.title, 'tnc_url': this.feedObject.channel.tnc_url, 'target_name': this.feedObject.channel.title, 'publication_logo': this.feedObject.channel.powered_by, 'subscribe_status': this.feedObject.channel.is_subscribed, 'channel_powered': this.feedObject.channel.powered_by_label, 'powered_name': this.feedObject.channel.powered_name };
            }

          }
          if (this.feedObject['feed_comment_list'].length > 0) {
            this.showComment = true;
            this.commentObj = { 'product_id': this.feedObject.feed_id, 'product_type': 1, 'comment': this.feedObject['feed_comment_list'], 'total_comment': this.feedObject['total_comments'], 'kind': this.feedObject['feed_kind'] };
          } else {
            this.showComment = false;
            this.commentObj = { 'product_id': this.feedObject.feed_id, 'product_type': 1, 'comment': [], 'total_comment': this.feedObject['total_comments'], 'kind': this.feedObject['feed_kind'] };
          }
        } else {
          this.fcs.errorHandeler(data);
          this.feedDetailModal = false;
          this.resetFeedDetailModal.emit(false);
        }
      });
    }));
  }

  /**
   * modal feed
   */
  modalfeed(): void {
    this.feedDetailModal = true;
    console.log('modalfeed');
    document.querySelector<HTMLInputElement>('#feed_modal_slide')?.focus();
  }

  /**
   * hide Modal
   */
  hideModal(): void {
    this.feedDetailModal = false;
    this.fcs.currentScreename = this.source;
    this.resetFeedDetailModal.emit(false);
  }

  /**
   * on Hidden
   */
  onHidden(): void {
    this.feedDetailModal = false;
    this.resetFeedDetailModal.emit(false);
  }

  /**
   * see More
   */
  seeMore(): void {
    this.see_more = true;
  }

  /**
   * see Less
   */
  seeLess(): void {
    this.see_more = false;
  }

  /**
   * share Comment Count To Parent
   */
  shareCommentCountToParent(process): void {
    if (process == 'add') {
      this.feedObject.total_comments = ++this.feedObject.total_comments;

    } else {
      this.feedObject.total_comments = --this.feedObject.total_comments;
    }
  }

  /**
   * call Like Component
   */
  callLikeComponent(action): void {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return;
    }

    if (action == 'set' && this.feedObject.like_status === 1) {
      return;
    }

    if (action == 'set') {
      this.feed_like_loader = true;
    }
    this.likeObj = { 'product_id': this.feedObject.feed_id, 'product_type': 1, 'callLikeProperty': action };
    this.showLikeListModal = true;
  }

  /**
   * reset Like Modal List
   */
  resetLikeModalList(val): void {
    this.showLikeListModal = val['reset'];
    const likeAction = val['reaction']['action'];
    if (likeAction == 'set' && this.feedObject['like_status'] != 1) {
      if (likeAction) {
        this.feedObject['like_status'] = 1;
        const likeListObj = [{ 'like_id': 0, 'user_id': 0, 'date_of_updation': 3432, 'date_of_creation': 34321, 'custom_id': this.loginUserCustomeId, 'name': 'You', 'profile_pic_path': this.userProfileData['profile'].profile_pic_path }];
        this.feedObject['like_list'] = likeListObj.concat(this.feedObject['like_list']);
        ++this.feedObject['total_like'];
      }
    }

  }
  /****************************EOF Like Section************************/

  /**
   * reset Like
   */
  resetLike(): void {
    this.feed_like_loader = false;
    this.showLikeListModal = false;
  }

  /**
   * set Bookmark
   */
  setBookmark(): boolean {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }

    this.feed_bookmark_loader = true;
    this.bookmarkObj = { product_id: this.feedObject.feed_id, product_type: 1 };
    this.is_bookmark = true;
  }

  /**
   * reset Bookmark
   */
  resetBookmark(resetObj): void {
    this.feed_bookmark_loader = false;
    if (resetObj === 1) {
      this.feedObject.archive = 1;
      this.feedObject.is_bookmarked = 1;
    } else if (resetObj === 0) {
      this.feedObject.archive = 0;
      this.feedObject.is_bookmarked = 0;
      const temp = { feed_id: this.feedObject.feed_id, idx: this.feedIdx };
      this.gws.feed_unbookmarked.next(temp);
    }
    this.is_bookmark = false;
  }

  /**
   * on Active Slide Change
   */
  onActiveSlideChange(event): void {
    this.useractivity = !this.useractivity;
    this.mediaIdx = event.relatedTarget;

  }

  /**
   * update Media Selector
   */
  updateMediaSelector(idx): void {
    this.mediaIdx = idx;
    this.useractivity = !this.useractivity;

  }

  /**
   * Poll On Feed
   */
  PollOnFeed(feed_id, option_id, poll_status): boolean {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }

    if (poll_status != 1) {
      this.subscriptions.add(this.postSer.feedPoll(feed_id, option_id).subscribe(resData => {
        this.jwtSer.decodeData(resData).then(data => {
          if (data['status'] == 1) {
            this.feedObject.poll = data['data'].poll;
            this.feedObject.poll_status = 1;
          } else if (data['status'] == 0) {
            this.fcs.errorHandeler(data);
            return;
          }
        });
      }));
    }
  }

  /**
   * set style for poll feed
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getMyStyles(per, poll_status): any {
    let myStyles;
    if (poll_status === 0) {
      myStyles = {
        'width': +'0%'
      };
    } else {
      myStyles = {
        'width': per + '%'
      };
      // console.log((myStyles));
    }
    return myStyles;
  }

  /**
   * product Share
   */
  productShare(): void {
    //   console.log(this.feedObject);
    const x = [{ share_url: this.feedObject.feed_share_url, share_contentt: this.feedObject.share_content, product_type: 1 }];
    this.fcs.productShare(x, SCREEN_NAME.FEED_DETAIL);
  }

  /**
   * product Like
   */
  productLike(): void {
    if (this.feed_like_loader == true) { return; }
    if (this.feedObject.like_status == 1) { return; }
    this.feed_like_loader = true;
    this.subscriptions.add(this.postSer.productLike(1, this.feedObject.feed_id, 'like').subscribe(resData => {
      this.feed_like_loader = false;
      this.jwtSer.decodeData(resData).then(data => {
        if (data['status'] == 1) {
          this.fcs.showSuccess(data['msg'], 'Success');
          this.feedObject.like_status = 1;
          this.feedObject.total_like = this.feedObject.total_like + 1;
        } else if (data['status'] == 0) {
          this.fcs.showError(data['msg'], 'Error');
          this.fcs.errorHandeler(data);
          return;
        }
      }, () => {
        this.feed_like_loader = false;
      });
    }));
  }

  /**
   * reset Comment
   */
  resetComment(): void {
    this.comment_box_obj = { profile_pic: '', product_type_id: '', product_id: '' };
  }

  /**
   * Function is used to get specialty tag details.
   */
  getFeedTagDetails(tagDetails): void {
    if (tagDetails.modalAction === 'close-modal') {
      this.feedDetailModal = false;
      this.resetFeedDetailModal.emit(false);
      this.dss.specialty_tag.next(tagDetails.speciality);
    }
  }

  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
  /**
   * Emit repost click from feed detail/
   */
  emitRepostData(): void {
    if (this.dss.post_process_obj.status === POSTING_PROGRESS.IN_PROGRESS) {
      this.fcs.showError('', this.mls.languageText.feed_card_screen.key22);
      return;
    }
    if (this.feedObject.repost_info !== null && this.feedObject.repost_info?.is_available === NUMBERS.ZERO) {
      this.fcs.showError('', this.mls.languageText.feed_detail.key15);
      return;
    } else if (this.feedObject.repost_info !== null && this.feedObject.repost_content?.data?.channel !== null && this.feedObject.repost_content?.data?.channel?.content_visibility?.display !==  NUMBERS.ONE) {
      this.fcs.showError('', this.mls.languageText.feed_card_screen.key21);
      return;
    } else if (this.feedObject.repost_content === null ) {
      this.dss.repostProductId = this.feedObject.product_type_id;
      this.dss.repostProductType = PRODUCT_TYPE_CONSTANT.FEED;
      this.dss.isRepostStatus = REPOST_STATUS.ONE;
      this.fcs.navigateToFeedDetail(NUMBERS.ZERO);
      this.dss.show_feed_post_modal.next(NUMBERS.ONE);
      this.dss.webinarRepostObject = this.feedObject;
      if (this.feedObject.user_profile?.custom_id && this.feedObject.user_profile?.custom_id !== this.dss.user_profile_data?.profile?.custom_id  && this.dss.user_profile_data?.profile?.permission === 'all') {
        this.dss.tagedUser.push(this.feedObject.user_profile);
        this.dss.posting_data.screen1.tag_to.push(this.feedObject.user_profile);
      }
    } else {
        this.dss.repostProductId = this.feedObject.repost_content.product_id;
        this.dss.repostProductType = this.feedObject.repost_content.product_type;
        this.dss.isRepostStatus = REPOST_STATUS.ONE;
        this.fcs.navigateToFeedDetail(NUMBERS.ZERO);
        this.dss.show_feed_post_modal.next(NUMBERS.ONE);
        this.dss.webinarRepostObject = this.feedObject.repost_content.data;
        if (this.feedObject.repost_content.product_type === NUMBERS.ONE  && this.feedObject.repost_content.data.user_profile?.custom_id &&
          this.feedObject.repost_content.data.user_profile?.custom_id !== this.dss.user_profile_data?.profile?.custom_id && this.dss.user_profile_data?.profile?.permission === 'all') {
          this.dss.tagedUser.push(this.feedObject.repost_content.data.user_profile);
          this.dss.posting_data.screen1.tag_to.push(this.feedObject.repost_content.data.user_profile);
        }
    }
    this.hideModal();
  }

}
